function proxyRegisterForPlugin(manager, registry, plugin) {
  return new Proxy(manager, {
    get(target, prop) {
      if (prop != "register") {
        return Reflect.get(target, prop);
      }
      return async function(...args) {
        const [type, extension] = args;
        return (async () => {
          return await registry.register(plugin, type, extension);
        })();
      };
    }
  });
}
export {
  proxyRegisterForPlugin
};
//# sourceMappingURL=pluginRegistryProxy.js.map
